import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';
import styles from './CartIcon.module.scss';
import CartIconSvg from '../icons/CartIconSvg';
const CartIcon = () => {
    const { items } = useCart();
    const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
    return (_jsxs(Link, { to: "/app/shoppingCart/", className: styles.cartIcon, children: [_jsx(CartIconSvg, { className: styles.cartIcon__icon }), itemCount > 0 && (_jsx("span", { className: styles.cartIcon__badge, "aria-label": `${itemCount} items in cart`, children: itemCount }))] }));
};
export default CartIcon;
